import { 
  GET_ACCESS_ROLE,
  GET_ACCESS_ROLE_SUCCESS,
  GET_ACCESS_ROLE_ERROR,

  GET_ACCESS_ROLES_LIST,
  GET_ACCESS_ROLES_LIST_SUCCESS,
  GET_ACCESS_ROLES_LIST_ERROR,
  
  CREATE_ACCESS_ROLE,
  CREATE_ACCESS_ROLE_SUCCESS,
  CREATE_ACCESS_ROLE_ERROR, 

  UPDATE_ACCESS_ROLE,
  UPDATE_ACCESS_ROLE_SUCCESS,
  UPDATE_ACCESS_ROLE_ERROR,

  DELETE_ACCESS_ROLE,
  DELETE_ACCESS_ROLE_SUCCESS,
  DELETE_ACCESS_ROLE_ERROR,
} from "./actionTypes"
  
  const initialState = {
    GET_ACCESS_ROLE_SUCCESS: "",
    GET_ACCESS_ROLE_ERROR: "",
    GET_ACCESS_ROLES_LIST_SUCCESS: "",
    GET_ACCESS_ROLES_LIST_ERROR: "",
    CREATE_ACCESS_ROLE_SUCCESS: "",
    CREATE_ACCESS_ROLE_ERROR: "",
    UPDATE_ACCESS_ROLE: "",
    UPDATE_ACCESS_ROLE_SUCCESS: "",
    UPDATE_ACCESS_ROLE_ERROR: "",
    DELETE_ACCESS_ROLE: "",
    DELETE_ACCESS_ROLE_SUCCESS: "",
    DELETE_ACCESS_ROLE_ERROR: "",
    loading: false,
  }
  
  const reducer = (state = initialState, action: any) => {
    switch (action.type) {
      // ---------------------------------------------GET_ACCESS_ROLE
      case GET_ACCESS_ROLE:
        state = {
          ...state,
          loading: true,
        }
        break

      case GET_ACCESS_ROLE_SUCCESS:
        state = {
          ...state,
          GET_ACCESS_ROLE_SUCCESS: action.payload,
          loading: false,
        }
        break

      case GET_ACCESS_ROLE_ERROR:
        state = { 
          ...state, 
          GET_ACCESS_ROLE_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------GET_ACCESS_ROLES_LIST
      case GET_ACCESS_ROLES_LIST:
        state = {
          ...state,
          loading: true,
        }
        break

      case GET_ACCESS_ROLES_LIST_SUCCESS:
        state = {
          ...state,
          GET_ACCESS_ROLES_LIST_SUCCESS: action.payload,
          loading: false,
        }
        break

      case GET_ACCESS_ROLES_LIST_ERROR:
        state = { 
          ...state, 
          GET_ACCESS_ROLES_LIST_ERROR: action.payload, 
          loading: false 
        }
        break
        
      // ---------------------------------------------CREATE_ACCESS_ROLE
      case CREATE_ACCESS_ROLE:
        state = {
          ...state,
          loading: true,
        }
        break

      case CREATE_ACCESS_ROLE_SUCCESS:
        state = {
          ...state,
          CREATE_ACCESS_ROLE_SUCCESS: action.payload,
          loading: false,
        }
        break

      case CREATE_ACCESS_ROLE_ERROR:
        state = { 
          ...state, 
          CREATE_ACCESS_ROLE_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------UPDATE_ACCESS_ROLE
      case UPDATE_ACCESS_ROLE:
        state = {
          ...state,
          loading: true,
        }
        break

      case UPDATE_ACCESS_ROLE_SUCCESS:
        state = {
          ...state,
          UPDATE_ACCESS_ROLE_SUCCESS: action.payload,
          loading: false,
        }
        break

      case UPDATE_ACCESS_ROLE_ERROR:
        state = { 
          ...state, 
          UPDATE_ACCESS_ROLE_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------DELETE_ACCESS_ROLE
      case DELETE_ACCESS_ROLE:
        state = {
          ...state,
          loading: true,
        }
        break

      case DELETE_ACCESS_ROLE_SUCCESS:
        state = {
          ...state,
          DELETE_ACCESS_ROLE_SUCCESS: action.payload,
          loading: false,
        }
        break

      case DELETE_ACCESS_ROLE_ERROR:
        state = { 
          ...state, 
          DELETE_ACCESS_ROLE_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------DEFAULT
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default reducer
  